// extracted by mini-css-extract-plugin
export var formContainer = "_i2-0";
export var message = "_i2-1";